import { findClosestCampusOption } from '@/lib/geo'
import { hasUniversityCoordinates } from '@/lib/locations/universityDataset'
import type { LocationCampusOption, LocationUniversityOption } from '@/lib/mock/locationPages'

export type BerlinUniversityFinderSelection = {
  selectedCampusSlug: string
  selectedUniversity: LocationUniversityOption | null
}

export function getNearestCampusForUniversity(
  university: Pick<LocationUniversityOption, 'latitude' | 'longitude' | 'nearestCampusSlug'>,
  campuses: LocationCampusOption[],
): LocationCampusOption | undefined {
  if (hasUniversityCoordinates(university)) {
    return findClosestCampusOption(
      [university.longitude, university.latitude],
      campuses,
    )
  }

  if (!university.nearestCampusSlug) {
    return undefined
  }

  return campuses.find((campus) => campus.slug === university.nearestCampusSlug)
}

/** Apply a university pick (or reset) for the Berlin city-map finder. */
export function applyUniversityFinderSelection(params: {
  autoSelectNearestCampus?: boolean
  campuses: LocationCampusOption[]
  university: LocationUniversityOption | null
}): BerlinUniversityFinderSelection {
  if (!params.university) {
    return {
      selectedCampusSlug: '',
      selectedUniversity: null,
    }
  }

  if (params.autoSelectNearestCampus === false) {
    return {
      selectedCampusSlug: '',
      selectedUniversity: params.university,
    }
  }

  const nearestCampus = getNearestCampusForUniversity(params.university, params.campuses)

  return {
    selectedCampusSlug: nearestCampus?.slug ?? '',
    selectedUniversity: params.university,
  }
}

export function shouldShowUniversityFinderRoute(
  selection: BerlinUniversityFinderSelection,
): boolean {
  return Boolean(
    selection.selectedUniversity &&
      selection.selectedCampusSlug &&
      selection.selectedUniversity.latitude != null &&
      selection.selectedUniversity.longitude != null,
  )
}
